import { render, staticRenderFns } from "./History_Index.vue?vue&type=template&id=fc62ec9c&scoped=true"
import script from "./History_Index.vue?vue&type=script&lang=js"
export * from "./History_Index.vue?vue&type=script&lang=js"
import style0 from "./History_Index.vue?vue&type=style&index=0&id=fc62ec9c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fc62ec9c",
  null
  
)

export default component.exports